// 头像上传入口校验
import i18n from "homeland/i18n";

const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
const TIP_CLASS = "avatar-size-tip";

function formatMB(bytes) {
  return (bytes / 1024 / 1024).toFixed(1);
}

document.addEventListener(
  "change",
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== "file") return;
    if (!/\[avatar\]$/.test(input.name || "")) return;

    // 移除上一次的提示
    const parent = input.parentElement;
    if (parent) {
      parent.querySelectorAll(`.${TIP_CLASS}`).forEach((el) => el.remove());
    }

    const file = input.files && input.files[0];
    if (!file) return;

    if (file.size > AVATAR_MAX_BYTES) {
      input.value = "";
      const tip = document.createElement("div");
      tip.className = `${TIP_CLASS} text-danger`;
      tip.style.marginTop = "0.25rem";
      tip.style.fontSize = "0.875rem";
      tip.textContent = i18n.t("common.avatar_too_large", {
        size: formatMB(file.size),
        max: 5,
      });
      if (parent) {
        parent.insertBefore(tip, input.nextSibling);
      }
    }
  },
  true
);
